import React, {FunctionComponent} from 'react';
import { GenericInput } from '../../../../../components/Form/GenericInput/GenericInput';

interface Props {
	IBAN: string;
	errorMessage: string | undefined;
	setIBAN(iban: string): void;
}

const IBAN: FunctionComponent<Props> = (props) => {
	return (
		<GenericInput
			label="IBAN"
			inputId="iban_input"
			error={props.errorMessage}
			setInputValue={props.setIBAN}
			inputValue={props.IBAN}
			additionalInputParams={{
				autoFocus: true,
			}}
		/>
	);
};

export default IBAN;
